import React from 'react';
import classes from './ControlPanel.module.scss';
import { Actions, Filters } from './components';

export const ControlPanel: React.VFC = () => {
  return (
    <div className={classes.root}>
      <div className={classes.filters}>
        <Filters />
      </div>
      <div className={classes.actions}>
        <Actions />
      </div>
    </div>
  );
};
